import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCustomizationGroupPartnerIndexQuerySchema } from '~/services/api/generated'

const schema = MenuCustomizationGroupPartnerIndexQuerySchema.strict()

// ListMenuCustomizationGroupsRequest
export const MenuCustomizationGroupPartnerIndex = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>> => schema
